
export const formatDateTime = (date) => {
    if (date) {
        return new Date(date.substring(0, 19)).toLocaleString();
    } else {
        return "-";
    }
}
